import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';

class BordereauPrisEnChargeDGFIPState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.TRAITE_DGFIP;
    this.state = BordereauStateType.TRAITE_DGFIP;
    this.color = '#70726E';
    this.libelle = 'Traité par la DGFIP';
  }

  getBordereauActions(
    _bordereau: BordereauWithState,
    userRole: UserRole,
  ): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole: UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauPrisEnChargeDGFIPState;
